import ModuleBase from "#/common/ModuleBase";

import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";
import { Observer } from "mobx-vue";
import { Component } from "vue-property-decorator";
// Template
import template from "./template.vue";

@Observer
@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
  },
})
export class TypeSelectionModule extends ModuleBase {
  public getBackgroundColorFromInstance(instance: object) {
    return "white";
  }

  public mounted() {
    this.initialize();
  }

  private async initialize() {
    if (!this.$store.typeSelectionFilter.hasConfigSelection) {
      await this.$store.typeSelectionFilter.loadFilterSession();
      await this.$store.typeSelectionFilter.loadTypeSelection();
    }
  }

  get showSelection() {
    return !this.instance["hide_selection"];
  }

  async setFilterValue(key, $event) {
    this.$store.typeSelectionFilter.setFilterValue(key, $event).then(() => {
      this.$eventBus.$emit("cms.vehicleconfigs.refresh");
    });
  }
}
